// src/hooks/useScroll.js
import { useState, useEffect, useCallback } from "react";

export const useScroll = (chatMessagesRef) => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToBottom = useCallback(() => {
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatMessagesRef]);

  const handleScrollToBottomClick = () => {
    scrollToBottom();
    setShowScrollButton(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (chatMessagesRef.current) {
        const { scrollTop, scrollHeight, clientHeight } =
          chatMessagesRef.current;
        setShowScrollButton(scrollTop + clientHeight < scrollHeight - 20);
      }
    };

    const chatMessagesElement = chatMessagesRef.current;
    if (chatMessagesElement) {
      chatMessagesElement.addEventListener("scroll", handleScroll);
      return () =>
        chatMessagesElement.removeEventListener("scroll", handleScroll);
    }
  }, [chatMessagesRef]);

  return { showScrollButton, scrollToBottom, handleScrollToBottomClick };
};
